import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { H4 } from '../Heading/Heading';
import { Heading, IconSpinner, NamedLink } from '../index';
import { AvatarMedium } from '../Avatar/Avatar';
import { createSlug } from '../../util/urlHelpers';
import { FormattedMessage } from '../../util/reactIntl';
import css from './TitleSection.module.css';

const TitleSection = ({
  isProviderRole,
  listing,
  shop,
  brand,
  transaction,
  onGetShop,
  onGetBrand,
  getHeadingInfoInProgress,
}) => {
  if ((!shop && !listing) || !transaction) return null;

  const intl = useIntl();

  useEffect(() => {
    if (listing?.attributes?.publicData?.storeId) {
      onGetShop(listing?.attributes?.publicData?.storeId);
    }
  }, [listing?.attributes?.publicData?.storeId]);

  useEffect(() => {
    if (isProviderRole) {
      onGetBrand(transaction?.customer?.id?.uuid);
    }
  }, []);

  const locationDetails = shop?.attributes?.publicData?.location
    ? shop?.attributes?.publicData?.location?.address
    : intl.formatMessage({ id: 'StripePaymentForm.locationUnknown' });

  if (getHeadingInfoInProgress)
    return (
      <div className={css.spinnerContainer}>
        <IconSpinner />
      </div>
    );

  return (
    <div>
      <div className={css.headingContainer}>
        <div className={css.avatarWrapper}>
          <AvatarMedium
            user={isProviderRole ? transaction?.customer : transaction?.provider}
            disableProfileLink
          />
        </div>
        <div className={css.titleContainer}>
          <H4 as="h2" className={css.heading}>
            {isProviderRole && brand ? (
              <NamedLink
                name="BrandListingPage"
                params={{
                  id: brand?.id?.uuid,
                  slug: createSlug(brand?.attributes?.title || ''),
                }}
              >
                {brand?.attributes?.title}
              </NamedLink>
            ) : (
              <NamedLink
                name="ListingPage"
                params={{
                  id: shop?.id?.uuid || listing?.attributes?.publicData?.storeId,
                  slug: createSlug(
                    shop?.attributes?.title || listing?.attributes?.publicData?.storeName || ''
                  ),
                }}
              >
                {shop?.attributes?.title || listing?.attributes?.publicData?.storeName}
              </NamedLink>
            )}{' '}
            <NamedLink
              className={css.newBrandLink}
              name="BrandListingPage"
              target="_blank"
              rel="noopener noreferrer"
              params={{
                id: brand?.id?.uuid,
                slug: createSlug(brand?.attributes?.title || ''),
              }}
            >
              <FormattedMessage id="TitleSection.viewBrandProfileLink" />
            </NamedLink>
          </H4>
          <H4 as="h2" className={css.topbarLinkHighlightLabel}>
            {isProviderRole && brand ? (
              <NamedLink
                name="BrandListingPage"
                params={{
                  id: brand?.id?.uuid,
                  slug: createSlug(brand?.attributes?.title || ''),
                }}
              >
                {intl.formatMessage({ id: 'TitleSection.managedBy' })}{' '}
                {transaction?.customer?.attributes?.profile?.displayName?.split(' ')?.[0]}
              </NamedLink>
            ) : (
              <NamedLink
                name="ListingPage"
                params={{
                  id: shop?.id?.uuid || listing?.attributes?.publicData?.storeId,
                  slug: createSlug(
                    shop?.attributes?.title || listing?.attributes?.publicData?.storeName || ''
                  ),
                }}
              >
                {intl.formatMessage({ id: 'TitleSection.managedBy' })}{' '}
                {transaction?.provider?.attributes?.profile?.displayName?.split(' ')?.[0]}
              </NamedLink>
            )}
          </H4>
        </div>
      </div>

      {/*<div className={css.locationWrapper}>*/}
      {/*  <Heading as="h3" rootClassName={css.locationHeading}>*/}
      {/*    <FormattedMessage id="StripePaymentForm.locationDetailsTitle" />*/}
      {/*  </Heading>*/}
      {/*  <p className={css.locationDetails}>{locationDetails}</p>*/}
      {/*</div>*/}
    </div>
  );
};

export default TitleSection;
